module.exports = __webpack_public_path__ + "img/interactive_platform_2.4ce37d80.png";